import React, { Component } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

class HomePage extends Component {

    componentDidMount () {
        const script = document.createElement("script");

        script.src = "https://5p4rk13.com/LiveFeed/17550/loaderscript.js";
        script.async = true;

        document.body.appendChild(script);
    }

    render() {
        return (
            <div>
                <ReactCSSTransitionGroup
                    transitionAppear={true}
                    transitionAppearTimeout={600}
                    transitionEnterTimeout={600}
                    transitionLeaveTimeout={200}
                    transitionName={'SlideIn'}
                >
                    <div className="middle">
                        <p>I januari lanserade vi på Food Pharmacy uppropet #sjukmat. Ett upprop som vi hoppas ska leda till att Sveriges beslutsfattare börjar ta sitt ansvar för att maten som serveras på Sveriges sjukhus, förskolor, skolor och äldreboenden följer de Nordiska Näringsrekommendationerna och bidrar till att göra oss friska, i stället för tvärtom.</p>
                        {/* <p>Stöd uppropet genom att gilla v&aring;r sida på <a href="https://www.facebook.com/sjukmat/">Facebook</a>. 
                        Och bidra g&auml;rna med din egna ber&auml;ttelse på <a href="https://www.facebook.com/sjukmat/">Facebook</a>, Instagram eller Twitter. Vi samlar alla inl&auml;gg som g&ouml;rs p&aring; v&aring;r Facebook-v&auml;gg eller under hashtaggen #sjukmat h&auml;r.</p> */}
                    </div>
                </ReactCSSTransitionGroup>

                <div className="main">
                    <div className="sprkl-wrapper Sparkle-17550" data-fixed-height="false" data-show-scrollbars="false" data-template="1" style={{height: '100%', width: '100%'}}></div>
                </div>
                
            </div>
        );
    }
}

export default HomePage;


// WEBPACK FOOTER //
// ./src/components/home/HomePage.js